module.exports = __webpack_public_path__ + "img/icons/link-6259567f740a5d10f7f92db6cc019ba4.svg";